module.exports = __webpack_public_path__ + "img/ph-bg.36e11669.webp";